import { CSSObject } from "@emotion/react";

import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { textXSObj, textMObj } = typographyStyles;
const grey = constants.colors.ui.neutral[500];
const greyLight = constants.colors.ui.neutral[100];

import { panelCss as activityPanelCss } from "@/view/ActivityPanel/ActivityPanel.style";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints } = constants;
const { md } = breakpoints.BreakpointNames;

export const panelCss = (isPanelVisible: boolean): CSSObject => ({
  ...activityPanelCss(isPanelVisible),
  position: "relative",
  borderRadius: "12px 12px 0 0",
  boxShadow: "0px -3px 10px rgba(0, 0, 0, 0.25)",
  overflow: "scroll",
  [mediaQuery.downTo(md)]: {
    boxShadow: "none",
  },
});

export const sectionCss = {
  padding: "1em",
};

export const sectionTitleCss: CSSObject = {
  textTransform: "uppercase",
  ...textXSObj,
};

export const sectionTextCss: CSSObject = {
  ...textMObj,
  color: grey,
};

export const panelItemWrapperCss: CSSObject = {
  padding: "0 20px 30px",
  marginBottom: "30px",

  ":not(:last-of-type)": {
    borderBottom: `1px solid ${greyLight}`,
  },
};

export const formativeLearnMoreWrapperCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  margin: "0",
  gap: ".5em",
};

export const activityListCss: CSSObject = {
  listStyle: "none",
  margin: 0,
  padding: 0,
  "& > li": {
    marginBottom: "1em",
    "&:last-child": {
      marginBottom: 0,
    },
  },
};
